import { render, staticRenderFns } from "./Spot.vue?vue&type=template&id=63f9b900&scoped=true"
import script from "./Spot.vue?vue&type=script&lang=js"
export * from "./Spot.vue?vue&type=script&lang=js"
import style0 from "./Spot.vue?vue&type=style&index=0&id=63f9b900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9b900",
  null
  
)

export default component.exports